import { cacheDom } from "../utils/QuerySelectors.js"
import { addItemsToCart } from "../utils/Cart.js"
import { getRebuyUpsells } from '../utils/Rebuy.js'
import { getProductsInfo } from '../utils/Storefront.js'
import { getUniqueCommonValues } from '../utils/helpers.js'

const dom = {}
const qs = {
  swatchVariant: 'data-swatch-variant',
}
const qsAll = {
  rebuyWidgets: 'data-recommend-rebuy-id',
}

export const setupPdpRebuyUpsells = () => {
  cacheDom(dom, qs, qsAll)
  dom.rebuyWidgets.forEach((rebuyWidget) => {
    const rebuyDatasourceId = rebuyWidget.dataset.recommendRebuyId
    const rebuyWidgetId = rebuyWidget.dataset.rebuyWidgetId
    const productIds = rebuyWidget.dataset.rebuyShopifyProductIds
    const limit = (typeof rebuyWidget.dataset.limit != 'undefined') ? parseInt(rebuyWidget.dataset.limit) : 2
    if (typeof rebuyDatasourceId != 'undefined' && rebuyDatasourceId) {
      const render = rebuyWidget.querySelector('[data-recommend-rebuy-render]')
      const swiperWrap = render.querySelector('.swiper-wrapper')
      
      getRebuyUpsells((items) => {
        let shopifyIds = []
        items.forEach((item, index) => {
          shopifyIds.push(`"gid://shopify/Product/${item.id}"`)
        })
        
        getProductsInfo((products) => {
          console.log('Rebuy Upsells', products)
          let count = 0
          products.forEach((product, index) => {
            if (count >= limit) return
            if (product.availableForSale) {
              let add = false
              if(window.completeTheLook.length > 0) {
                add = product.variants.edges.filter(edge => getUniqueCommonValues(window.completeTheLook, JSON.parse(edge.node.look?.value || '[]')).length > 0).length
              } else {
                add = true
              }
              if(add) {
                if(window.completeTheLook.length > 0) {
                  const newEdges = product.variants.edges.filter(edge => getUniqueCommonValues(window.completeTheLook, JSON.parse(edge.node.look?.value || '[]')).length > 0)
                  product.variants.edges = newEdges
                }
                const newProductTile = document.createElement('div')
                newProductTile.classList.add('swiper-slide', '!h-auto')
                newProductTile.setAttribute('product-tile', 'true')
                product.rebuyWidgetId = rebuyWidgetId
                product.collectionBadges = product.collections.edges.map((edge) => edge.node.tile_message ? edge.node.tile_message.value : null )
                product.pairingOption = JSON.parse(product.pairingOption?.value || '[]')
                newProductTile.setAttribute('props', JSON.stringify(product))
                swiperWrap.appendChild(newProductTile)
                count += 1
              }
            }
          })
          window.setupProductTiles(swiperWrap.querySelectorAll('[product-tile]'))
          
          new Swiper(render, {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 15,
            loop: false,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            a11y: {
              slideRole: '',
              slideLabelMessage: '', 
            },
          })
          const addAllBtn = rebuyWidget.querySelector('[data-pdp-upsells-add-all]')
          addAllBtn.disabled = false
          addAllBtn.addEventListener('click', () => {
            addAllBtn.disabled = true
            addAllBtn.classList.add('loading')
            const items = Array.from(rebuyWidget.querySelectorAll(`.selected[${qs.swatchVariant}]`))
              .map(swatch => { 
                return { id: swatch.getAttribute(qs.swatchVariant), quantity: 1 }
              })
            if(items.length > 0) {
              addItemsToCart(items, true, addAllBtn)
            }
          })

          if(count == 0) rebuyWidget.classList.add('hidden')
        }, shopifyIds.join(','))
      }, rebuyDatasourceId, productIds)
    }
  })
}